module.exports = __webpack_public_path__ + "static/media/cut.427075db.svg";